<template>
  <div class="login-container">
    <div class="login-content">
      <div class="title-container">
        <img
          class="logo"
          src="https://static.gaojidata.com/gaojidata/logo/new-title-blue.svg"
          alt=""
        />
      </div>
      <div class="phone-register">
        <p>
          已有账号，马上<a href="javascript:void(0)" @click="goto_login"
            >登录</a
          >
        </p>
        <div class="step-box">
          <div class="h3">绑定手机</div>
          <ul>
            <template v-for="(item, index) in setpData">
              <li :key="index">
                <div class="space-line" v-if="index != 1"></div>
                <dl v-if="curStep > index" class="active">
                  <dd><i class="el-icon-check"></i></dd>
                  <dd>{{ item.name }}</dd>
                </dl>
                <dl v-else-if="curStep == index" class="active">
                  <dd>{{ item.index }}</dd>
                  <dd>{{ item.name }}</dd>
                </dl>
                <dl v-else>
                  <dd>{{ item.index }}</dd>
                  <dd>{{ item.name }}</dd>
                </dl>
              </li>
            </template>
          </ul>
        </div>
        <template v-if="curStep == 0">
          <el-form
            label-position="top"
            :model="checkForm"
            :rules="checkRulesForm"
            ref="checkForm"
            :key="'checkRulesForm'"
            label-width="100px"
          >
            <el-form-item label="账号验证" prop="account" class="no-tips">
              <el-input
                placeholder="请输入当前账号"
                v-model="checkForm.account"
                maxlength="20"
              >
              </el-input>
              <span
                slot="error"
                slot-scope="error"
                class="el-form-item__error"
                >{{ error.error }}</span
              >
            </el-form-item>
            <el-form-item label="密码验证" prop="password" class="no-tips">
              <!-- <el-input type="password" v-model="ruleForm.password" autocomplete="off"></el-input> -->
              <el-input
                :type="showPassword ? 'text' : 'password'"
                maxlength="32"
                v-model="checkForm.password"
                autocomplete="off"
                placeholder="请输入当前账号密码"
                ref="password"
              >
                <i
                  slot="suffix"
                  class="el-icon-invisible"
                  @click="showPwd('showPassword')"
                  :class="{ see: showPassword }"
                ></i>
              </el-input>
              <span
                slot="error"
                slot-scope="error"
                class="el-form-item__error"
                >{{ error.error }}</span
              >
            </el-form-item>
            <el-form-item>
              <el-button
                :loading="loading"
                type="button"
                @click="submitForm('checkForm')"
                >下一步</el-button
              >
            </el-form-item>
          </el-form>
        </template>
        <template v-else-if="curStep == 1">
          <el-form
            label-position="top"
            :model="bindMobileForm"
            :rules="passwordRulesForm"
            :key="'passwordRulesForm'"
            ref="bindMobileForm"
            label-width="100px"
          >
            <el-form-item
              label="手机号码"
              class="prefix-box no-tips"
              prop="mobile"
            >
              <el-input
                placeholder="请输入要绑定的手机号码"
                v-model="bindMobileForm.mobile"
                maxlength="11"
              >
                <i slot="prefix">＋86</i>
              </el-input>
              <span
                slot="error"
                slot-scope="error"
                class="el-form-item__error"
                >{{ error.error }}</span
              >
            </el-form-item>
            <div style="display: flex">
              <el-form-item
                label="短信验证码"
                prop="authCode"
                class="no-tips"
                style="width: calc(100% - 114px); margin-right: 10px"
              >
                <el-input
                  v-model="bindMobileForm.authCode"
                  placeholder="请输入短信验证码"
                  maxlength="6"
                >
                </el-input>
                <span
                  slot="error"
                  slot-scope="error"
                  class="el-form-item__error"
                  >{{ error.error }}</span
                >
              </el-form-item>
              <el-form-item :label="' '" class="get-check_code">
                <el-input
                  type="button"
                  :loading="loading"
                  :value="value"
                  @click.native="getCode('bindMobileForm')"
                  :class="{ wait: waiting }"
                ></el-input>
              </el-form-item>
            </div>
            <el-form-item>
              <el-button
                :loading="loading"
                type="button"
                @click="bindPhone('bindMobileForm')"
                >确定</el-button
              >
            </el-form-item>
          </el-form>
        </template>
        <template v-else>
          <div class="change-success-box">
            <dl>
              <dd>
                <img
                  src="~@/assets/images/pic_box_success.png"
                  alt=""
                  srcset=""
                />
              </dd>
              <dd>{{ times }}秒后自动跳转</dd>
            </dl>
          </div>
        </template>
      </div>
      <div class="tips">
        建议使用<i class="el-icon-login-chrome"></i>Chrome浏览器
      </div>
    </div>
    <div class="footer-content">
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import { validUsername } from "@/utils/validate";
import Footer from "@/components/Footer/index.vue";
import { addMobileCheck, sendSmsAuthCode, saveMobile } from "@/api/login";
import { mapMutations } from "vuex";
import { setTokenTime } from "@/utils/auth";
export default {
  name: "phone_register",
  components: { Footer },
  data() {
    var validatePhone = (rule, value, callback) => {
      const reg = /^[1][3-9][0-9]{9}$/;
      if (value == "" || value == undefined || value == null) {
        callback();
      } else {
        if (!reg.test(value) && value != "") {
          callback(new Error("请输入正确的手机号码"));
        } else {
          callback();
        }
      }
    };
    var checkaccount = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("账号不能为空"));
      } else {
        callback();
      }
    };

    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (!/^(?![0-9]*$)(?![a-zA-Z]*$)[a-zA-Z0-9]{6,32}$/.test(value)) {
          callback(new Error("请输入6-32位英文字母和数字的组合")); // 或者符号（除空格），且字母、数字和标点符号至少包含两种
        } else {
          if (this.ruleForm.checkPass !== "") {
            this.$refs.ruleForm.validateField("checkPass");
          }
          callback();
        }
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      }
      if (!/^(?![0-9]*$)(?![a-zA-Z]*$)[a-zA-Z0-9]{6,32}$/.test(value)) {
        // ([^\u4e00-\u9fa5\s])
        callback(new Error("请输入6-32位英文字母和数字的组合"));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    var validateEMail = (rule, value, callback) => {
      const reg = /^([a-zA-Z0-9]+[-_\.]?)+@[a-zA-Z0-9\.]+\.[a-z]+$/;
      if (value == "" || value == undefined || value == null) {
        callback(new Error("请输入正确的邮箱"));
      } else {
        if (!reg.test(value)) {
          callback(new Error("请输入正确的邮箱"));
        } else {
          callback();
        }
      }
    };

    var validateNumber = (rule, value, callback) => {
      let numberReg = /^\d+$/;
      if (value !== "") {
        if (!numberReg.test(value)) {
          callback(new Error("请输入6位数字验证码"));
        } else {
          callback();
        }
      } else {
        callback(new Error("验证码不能为空"));
      }
    };
    return {
      showPassword: false,
      showCheckPass: false,
      showaccount: false,
      automaticallyLogin: false,
      loading: false,
      waiting: false,
      curStep: 0,
      times: 3,
      value: "获取验证码",
      setpData: [
        { index: 1, name: "安全认证" },
        { index: 2, name: "绑定号码" },
        { index: 3, name: "绑定成功" },
      ],
      checkForm: {
        account: "",
        password: "",
      },
      bindMobileForm: {
        mobile: "",
        authCode: "",
      },
      checkRulesForm: {
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" },
        ],
        account: [{ required: true, message: "账号不能为空", trigger: "blur" }],
      },
      passwordRulesForm: {
        mobile: [
          { required: true, message: "手机号码不能为空", trigger: "blur" },
          { validator: validatePhone, trigger: "blur" },
        ],
        authCode: [
          { required: true, message: "验证码不能为空", trigger: "blur" },
          { min: 6, max: 6, message: "请输入6位数字验证码", trigger: "blur" },
          { validator: validateNumber, trigger: "bulr" },
        ],
      },
    };
  },
  methods: {
    ...mapMutations("login", ["SET_LOGINTYPE"]),
    goto_login() {
      this.SET_LOGINTYPE("message");
      this.$router.push({ path: "/login" });
    },
    showPwd(name) {
      this[name] = !this[name];
    },
    async login(params) {
      const data = await login(params);
    },
    getCode(form) {
      if (this.waiting) {
        return;
      }
      this.$refs[form].validateField(["mobile"], (valid) => {
        this.loading = true;
        if (!valid) {
          sendSmsAuthCode({ mobile: this[form].mobile, flag: 0 })
            .then((res) => {
              this.waiting = true;
              this.value = "59s";
              this.countdown(
                59,
                () => {
                  this.value = "获取验证码";
                  this.waiting = false;
                },
                "value"
              );
              this.$message.success("验证码已发送，请注意查收");
              this.loading = false;
            })
            .catch((err) => {
              this.loading = false;
            });
        } else {
          console.log("error submit!!");
          this.loading = false;
          return false;
        }
      });
    },
    submitForm(form) {
      this.curStep += 1;
      return;
      this.loading = true;
      this.$refs[form].validate((valid) => {
        if (valid) {
          addMobileCheck(this[form])
            .then((res) => {
              this.curStep += 1;
              this.loading = false;
            })
            .catch((err) => {
              this.loading = false;
            });
        } else {
          console.log("error submit!!");
          this.loading = false;
          return false;
        }
      });
    },

    // 绑定手机号
    bindPhone(form) {
      this.loading = true;
      this.$refs[form].validate((valid) => {
        if (valid) {
          const postData = {
            ...this[form],
            account: this.checkForm.account,
          };
          saveMobile(postData)
            .then((res) => {
              this.curStep += 2;
              this.countdown(
                3,
                () => {
                  // this.SET_LOGINTYPE('message');
                  // this.$router.push('/login');
                  this.$store
                    .dispatch("user/login", { ...this[form], flag: 0 })
                    .then((res) => {
                      setTokenTime(Date.now());
                      this.$router.push({ path: "/" });
                      this.loading = false;
                    })
                    .catch((err) => {
                      console.log(err);
                      this.loading = false;
                    });
                },
                "times"
              );
              this.loading = false;
            })
            .catch((err) => {
              this.loading = false;
            });
        } else {
          console.log("error submit!!");
          this.loading = false;
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    countdown(remainTime, callback, updateText) {
      let times = setTimeout(() => {
        remainTime--;
        this[updateText] = remainTime;
        if (remainTime > 0) {
          this.countdown(remainTime, callback, updateText);
        } else {
          callback();
        }
        clearTimeout(times);
      }, 1000);
    },
  },
};
</script>

<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

.el-form--label-top .el-form-item__label {
  line-height: 14px;
  min-height: 24px;
  min-width: 1px;
}
.get-check_code {
  input {
    &:focus {
      box-shadow: none !important;
    }
    border-color: #514def;
    color: #514def;
    background-color: #ffffff;
    cursor: pointer;
    &:hover {
      color: #ffffff;
      background-color: #5f5bfb;
      border-color: #5f5bfb;
    }
    &.diabled {
      color: #c4c3ef;
      background-color: #ffffff;
      border-color: #d8d7fe;
    }
  }
  .wait {
    input,
    input:hover {
      cursor: not-allowed;
      color: #c4c3ef;
      border-color: #d8d7fe;
      background-color: #ffffff;
      width: 100px;
    }
  }
}
.prefix-box {
  .el-input--medium .el-input__inner {
    padding-left: 58px;
  }
}
</style>

<style lang="scss" scoped>
$bg: #e1e1e1;
$dark_gray: #889aa4;
$light_gray: #eee;

.login-container {
  min-height: 768px;
  padding-top: 20px;
  width: 100%;
  overflow: hidden;
  background: url("~@/assets/images/bg_login.png") no-repeat;
  background-size: 100% auto;
  background-position: center bottom;
  background-color: #f7f7fc;
  .login-content {
    min-height: calc(100vh - 149px);
    width: 462px;
    position: relative;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .title-container {
      height: 67px;
      text-align: center;
      .logo {
        height: 100%;
        width: 180px;
        transform: translateY(15px);
        display: inline-block;
        //background: url('~@/assets/newLogo.png') no-repeat;
        //background-position: center center;
        //background-size: 100% auto;
      }
    }
    .phone-register {
      height: 512px;
      max-height: 100%;
      position: relative;
      padding: 0 47px;
      box-shadow: 0px 5px 21px 0px rgba(81, 77, 239, 0.08);
      border-radius: 5px;
      box-sizing: border-box;
      background: #ffffff;
      position: relative;
      margin: 60px 0 20px;
      p {
        position: absolute;
        top: -27px;
        right: 0;
        font-size: 14px;
        font-family: "Source Han Sans SC";
        font-weight: 400;
        color: #343438;
        height: 14px;
        line-height: 14px;
        a {
          color: #514def;
          // text-decoration: underline;
          border-bottom: solid thin;
          display: inline-block;
        }
      }
      .change-success-box {
        height: calc(100% - 181px);
        display: flex;
        justify-content: center;
        align-items: center;
        dl {
          display: inline-block;
          font-size: 14px;
          font-family: "Source Han Sans SC";
          font-weight: 400;
          color: #514def;
          text-align: center;
          dd {
            &:first-child {
              margin-bottom: 19px;
            }
          }
        }
      }
      .step-box {
        margin-bottom: 30px;
        .h3 {
          text-align: center;
          height: 16px;
          font-size: 16px;
          line-height: 16px;
          font-family: "Source Han Sans SC";
          font-weight: bold;
          color: #444444;
          margin: 30px 0 24px;
        }
        ul {
          display: flex;
          li {
            text-align: center;
            width: calc(100% / 3);
            position: relative;
            .space-line {
              position: absolute;
              width: calc(100% - 40px);
              height: 1px;
              background: #c1c1c1;
              top: 14px;
            }
            dl {
              // cursor: pointer;
              display: inline-flex;
              // display: flex;
              flex-direction: column;
              align-items: center;
              color: #cacad1;
              text-align: center;
              width: 60px;
              dd {
                font-size: 14px;
                &:first-child {
                  border-radius: 50%;
                  font-size: 12px;
                  border: solid thin;
                  width: 28px;
                  height: 28px;
                  line-height: 28px;
                  margin: 0 auto;
                  margin-bottom: 9px;
                }
                &:last-child {
                  height: 14px;
                  line-height: 14px;
                }
              }
              &.active {
                color: #514def;
              }
            }
            &:first-child {
              text-align: left;
              .space-line {
                right: -20px;
              }
            }
            &:last-child {
              text-align: right;
              .space-line {
                left: -20px;
              }
            }
          }
        }
      }
      .el-icon-invisible {
        display: inline-block;
        width: 36px;
        height: 100%;
        background: url("~@/assets/images/btn_key_invisible_normal.png")
          no-repeat;
        background-position: center;
        cursor: pointer;
        &:hover {
          background-image: url("~@/assets/images/btn_key_invisible_hover.png");
        }
        &.see {
          background-image: url("~@/assets/images/btn_key_visible_normal.png");
          &:hover {
            background-image: url("~@/assets/images/btn_key_visible_hover.png");
          }
        }
      }
      .config-box {
        display: flex;
        justify-content: space-between;
        & > span:first-child {
          display: flex;
          align-items: center;
          color: #444444;
        }
        & > span:last-child {
          color: #a4a4ad;
        }
      }
      .el-form-item__error {
        color: #f56c6c;
        font-size: 12px;
        line-height: 1;
        padding-top: 4px;
        position: absolute;
        left: initial;
        top: -10px;
        right: 0px;
        transform: translateY(-100%);
      }
      .el-form-item {
        margin-bottom: 17px;
        &.prefix-box {
          .el-input--medium .el-input__inner {
            padding-left: 52px;
          }
          span.el-input__prefix {
            width: 43px;
            i {
              font-style: normal;
              color: #343438;
              font-size: 14px;
              line-height: 16px;
              height: 16px;
              display: inline-block;
              margin-top: 14px;
              border-right: solid thin #e1e1e3;
              width: 48px;
              text-align: center;
              margin-left: -5px;
            }
          }
        }
      }
      .el-button {
        width: 100%;
        margin-top: 113px;
        height: 42px;
        background: #514def;
        border-radius: 4px;
        font-size: 14px;
        font-family: "Source Han Sans SC";
        font-weight: 400;
        color: #ffffff;
        border: none;
      }
    }
    .tips {
      margin-top: 16px;
      text-align: center;
      color: #a4a4ad;
      font-size: 14px;
      .el-icon-login-chrome {
        background: url("~@/assets/images/icon_login_chrome.png") no-repeat;
        background-position: center center;
        margin: 0 4px;
        display: inline-block;
        width: 14px;
        height: 14px;
      }
    }
  }
  .footer-content {
    height: 68px;
    margin-bottom: 61px;
  }
}

@media only screen and (max-width: 1366px) {
  .login-container {
    min-height: 550px;
    padding-top: 20px;
    .login-content {
      min-height: calc(100vh - 119px);
      .title-container {
        height: 67px;
      }
      .phone-register {
        height: 482px;
        margin: 40px 0 20px;
        .el-button {
          width: 100%;
          margin-top: 107px;
          height: 36px;
        }
        .step-box {
          margin-bottom: 16px;
          .h3 {
            text-align: center;
            height: 16px;
            margin: 30px 0 20px;
          }
          ul {
            display: flex;
            li {
              text-align: center;
              width: calc(100% / 3);
              position: relative;
              .space-line {
                position: absolute;
                width: calc(100% - 40px);
                height: 1px;
                background: #c1c1c1;
                top: 14px;
              }
            }
          }
        }
      }
    }
    .footer-content {
      margin-bottom: 30px;
    }
  }
}
</style>
